import { render, staticRenderFns } from "./ProductsLiabilityBenefitsCustom.vue?vue&type=template&id=208b8895"
import script from "./ProductsLiabilityBenefitsCustom.vue?vue&type=script&lang=js"
export * from "./ProductsLiabilityBenefitsCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports